import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export default function Signup() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('Loader');
  const navigate = useNavigate();

  const signup = async () => {
    try {
      const res = await axios.post(`${backendUrl}/api/signup`, {
        username,
        password,
        role,
      });
      if (res.data.success) {
        alert('Signup successful! Please login.');
        navigate('/login');
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      alert('Server error or username exists');
    }
  };

  return (
    <div className="h-screen w-full">
      {/* Small screen layout (stacked vertically) */}
      <div className="flex flex-col md:hidden h-screen bg-black text-white">
        <div className="p-6 flex items-center justify-center h-1/4">
          <h3 className="text-xl sm:text-2xl font-extrabold text-center leading-snug">
            Join our <span className="text-orange-400">Truck Packing</span> system!
          </h3>
        </div>

        <div className="flex justify-center items-center h-3/4 px-4">
          <div className="w-full max-w-md border-2 border-orange-500 rounded-xl shadow-2xl p-6 bg-black">
            <h1 className="text-2xl font-extrabold mb-4 text-orange-500 text-center">Create Account</h1>

            <input
              className="mb-4 p-3 w-full bg-gray-900 border border-orange-500 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <input
              className="mb-4 p-3 w-full bg-gray-900 border border-orange-500 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <select
              className="mb-6 p-3 w-full bg-gray-900 border border-orange-500 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="Loader">Loader</option>
              <option value="Admin">Admin</option>
            </select>

            <button
              onClick={signup}
              className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 py-2 rounded-full w-full transition hover:scale-105"
            >
              Sign Up
            </button>
          </div>
        </div>
      </div>

      {/* Large screen layout (side-by-side) */}
      <div className="hidden md:flex h-screen text-white font-sans">
        <div className="w-2/5 flex justify-center items-center bg-black p-6">
          <div className="w-full max-w-md bg-black border-2 border-orange-500 rounded-xl shadow-2xl p-8 flex flex-col items-center">
            <h1 className="text-3xl font-extrabold mb-2 text-orange-500 tracking-wide">Create Account</h1>

            <input
              className="mb-4 p-3 w-full bg-gray-900 border border-orange-500 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 transition"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <input
              className="mb-4 p-3 w-full bg-gray-900 border border-orange-500 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 transition"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <select
              className="mb-6 p-3 w-full bg-gray-900 border border-orange-500 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 transition"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="Loader">Loader</option>
              <option value="Admin">Admin</option>
            </select>

            <button
              onClick={signup}
              className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-8 py-2 rounded-full shadow-md transition transform hover:scale-105"
            >
              Sign Up
            </button>
          </div>
        </div>

        <div className="w-3/5 bg-black flex-col justify-center p-12 space-y-12 flex">
          <h3 className="text-white font-extrabold text-4xl leading-snug">
            Join our <span className="text-orange-400">Truck Packing</span> system!
          </h3>
        </div>
      </div>
    </div>
  );
}
